import { Component, createRef } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import { IFollowUpSurveyForList } from '@nkr/models/index';
import { FollowUpStatus, FollowUpSurveyListType } from '@nkr/enums/index';
import { SurveyAction } from './survey-action';
import { menuItemList } from '../menu-item-list';

export const getUrl = (isAdmin: boolean, action: SurveyAction, id: number, data: IFollowUpSurveyForList) => {
    let hrefPrefix = isAdmin ? '/admin/follow-up' : `/center/${data.centerId}/follow-up`;

    switch (action) {
        case SurveyAction.View: return `${hrefPrefix}/survey/${id}/view`;
        case SurveyAction.MarkComplete: return `${hrefPrefix}/survey/${id}/mark-complete`;
    }

    return null;
}

export const getMenuItems = (data: IFollowUpSurveyForList | any) => {
    let menuItems = [
        SurveyAction.View,
        SurveyAction.GetPDF
    ];

    if (data.statusId == FollowUpStatus.DirectPendingAppointment) {
        menuItems.push(SurveyAction.MarkAppointmentBooked);
    }

    if (data.statusId < FollowUpStatus.Complete || (data.areLabResultsGood == false && data.isNotifiedOfLabResults == false)) {
        menuItems.push(SurveyAction.MarkComplete);
    }

    if (data.statusId < FollowUpStatus.Complete) {
        menuItems.push(SurveyAction.FollowUpUnsuccessful);
    }

    if ([FollowUpStatus.QuestPendingLabOrder, FollowUpStatus.PhlebotPendingRequisition].indexOf(data.statusId) >= 0) {
        menuItems.push(SurveyAction.UploadRequisition);
        menuItems.push(SurveyAction.RequisionAlreadySent);
    }

    if (data.statusId == FollowUpStatus.PendingSurvey) {
        menuItems.push(SurveyAction.PhoneInterviewSurvey);
        menuItems.push(SurveyAction.ResendSurveyEmail);
    }

    return menuItems;
}

interface IProps {
    listType: FollowUpSurveyListType,
    isAdmin: boolean,
    isAdminLogin: boolean,
    pullRight?: boolean,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (id: number, action: SurveyAction) => void
}

export class ActionButtonRenderer extends Component<ICellRendererParams & IProps, {}> {
    myDropdown: any = createRef();

    componentDidMount = () => {
    }

    handleMenuToggle = (show: boolean) => {
        this.props.onMenuToggle(show);
    };

    handleMenuSelection = (id: any, action: number) => {
        this.props.onItemSelected(id, action);
    }

    getUrl = (action: SurveyAction, id: number) => {
        let data = this.props.data as IFollowUpSurveyForList;
        return getUrl(this.props.isAdmin, action, id, data);
    }

    getMenuItems = () => {
        let data = this.props.data as IFollowUpSurveyForList;
        return getMenuItems(data);
    }

    render = () => {
        const dataLength = this.props.api.getModel().getRowCount();
        const dropup = dataLength <= 18 ? false : this.props.rowIndex + 1 > dataLength - 6;

        const menuItems = this.getMenuItems().map(item => {
            return menuItemList.find(x => x.action == item);
        });

        const menu = menuItems.map(item => {
            let url = item.action != -1 ? this.getUrl(item.action, this.props.data.id) : null;
            let id = item.action >= 0 ? this.props.data.id : 'div-' + this.props.data.id + '-' + Math.random() * 10000;

            if (url == null) {
                if (item.action >= 0) {
                    return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</>, url: null };
                } else {
                    return { id, action: item.action, include: true, selectable: false, element: <div style={{ height: 10 }}></div>, divider: true };
                }
            } else {
                return { id, action: item.action, include: true, selectable: false, element: <a href={url}>{item.title}</a>, url, title: item.title };
            }
        });

        return (
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
                includeCaret={true}
                onToggle={this.handleMenuToggle}
                onSelect={this.handleMenuSelection}
            />
        );
    }
}